import { shallowMount } from "@vue/test-utils";
import CuilNumberInput from "@/components/core/composite/combos/CuilNumberInput";

describe("CuilNumberInput component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(CuilNumberInput);
  });

  it("Renders del component CuilNumberInput", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
